import axios from 'axios';

export function addMovements(customerId, movementsFile) {
    const formData = new FormData();
    formData.append('movementsFile', movementsFile);

    return axios({
        method: 'post',
        url: `/api/warehousing/invoicing/import/${customerId}`,
        data: formData,
    });
}
